module.exports = __webpack_public_path__ + "static/media/register-background.64320f6e.jpg";